// Environment configuration for the frontend
const config = {
  paddle: {
    environment: process.env.REACT_APP_PADDLE_ENVIRONMENT || "sandbox",
    clientToken:
      process.env.REACT_APP_PADDLE_CLIENT_TOKEN ||
      "test_c7c7f27e2debd9c9e1d5a35ce82",
    plans: {
      monthly: {
        priceId:
          process.env.REACT_APP_PADDLE_MONTHLY_PRICE_ID ||
          "pri_01jfg8vz7t4z4vjt7cp23hfynp",
        amount: 19,
        interval: "month",
      },
      yearly: {
        priceId:
          process.env.REACT_APP_PADDLE_YEARLY_PRICE_ID ||
          "pri_01jfn92w9nzzma6qcyr8jqbaj4",
        amount: 199,
        interval: "year",
      },
    },
  },
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || "https://sqlguroo.com",
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
  },
  features: {
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === "true",
    debugMode: process.env.REACT_APP_DEBUG_MODE === "true",
  },
};

// Validation
if (
  !config.paddle.clientToken ||
  config.paddle.clientToken === "your_paddle_client_token_here"
) {
  console.warn("Paddle client token not configured properly");
}

export default config;
